import { baseApi } from "./base.api";

export const FAQsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchFAQs: build.query({
      query: (params) => ({ url: "/faqs/fetch", method: "GET", params }),
      providesTags: ["FAQs"],
    }),
    fetchFAQsAll: build.query({
      query: () => ({ url: "/faqs/fetch/all", method: "GET" }),
      providesTags: ["FAQs"],
    }),
    fetchTrashedFAQs: build.query({
      query: (params) => ({ url: "/faqs/fetch/trashed", method: "GET", params }),
      providesTags: ["FAQs"],
    }),
    fetchFAQById: build.query({
      query: (id) => ({ url: `/faqs/fetch/${id}`, method: "GET" }),
      providesTags: ["FAQs"],
    }),
    createFAQ: build.mutation({
      query: (body) => ({ url: "/faqs/create", method: "POST", body }),
      invalidatesTags: ["FAQs"],
    }),
    updateFAQ: build.mutation({
      query: ({ id, body }) => ({ url: `/faqs/update/${id}`, method: "PUT", body }),
      invalidatesTags: ["FAQs"],
    }),
    changeFAQStatus: build.mutation({
      query: (id) => ({ url: `/faqs/status/${id}`, method: "PUT" }),
      invalidatesTags: ["FAQs"],
    }),
    restoreFAQ: build.mutation({
      query: (id) => ({ url: `/faqs/restore/${id}`, method: "PUT" }),
      invalidatesTags: ["FAQs"],
    }),
    bulkRestoreFAQs: build.mutation({
      query: (body) => ({ url: "/faqs/bulk-restore", method: "POST", body }),
      invalidatesTags: ["FAQs"],
    }),
    deleteFAQ: build.mutation({
      query: (id) => ({ url: `/faqs/delete/${id}`, method: "DELETE" }),
      invalidatesTags: ["FAQs"],
    }),
    bulkDeleteFAQs: build.mutation({
      query: (body) => ({ url: "/faqs/bulk-delete", method: "POST", body }),
      invalidatesTags: ["FAQs"],
    }),
    destroyFAQ: build.mutation({
      query: (id) => ({ url: `/faqs/destroy/${id}`, method: "DELETE" }),
      invalidatesTags: ["FAQs"],
    }),
    bulkDestroyFAQs: build.mutation({
      query: (body) => ({ url: "/faqs/bulk-destroy", method: "POST", body }),
      invalidatesTags: ["FAQs"],
    }),
  }),
});

export const {
  useFetchFAQsQuery,
  useFetchFAQsAllQuery,
  useFetchTrashedFAQsQuery,
  useFetchFAQByIdQuery,
  useCreateFAQMutation,
  useUpdateFAQMutation,
  useChangeFAQStatusMutation,
  useRestoreFAQMutation,
  useBulkRestoreFAQsMutation,
  useDeleteFAQMutation,
  useBulkDeleteFAQsMutation,
  useDestroyFAQMutation,
  useBulkDestroyFAQsMutation,
} = FAQsApi;
